import React from "react";
import CIcon from "@coreui/icons-react";
import { freeSet } from "@coreui/icons";

const _navPartner = [
  {
    _tag: "CSidebarNavItem",
    name: "Home",
    to: "/partner/dashboard",
    icon: <CIcon name="cil-chart-pie" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Loan Book",
    route: "/loan",
    icon: "cil-notes",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Requests",
        to: "/partner/loan/request",
        badge: {
          color: "success",
          text: "0",
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: "Active",
        to: "/partner/loan/disbursed",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Overdue",
        to: "/partner/loan/unpaid",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Settled",
        to: "/partner/loan/paidup",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Client",
    route: "/partner/employee",
    icon: "cil-user",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Active client",
        to: "/partner/client/list",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Blocked client",
        to: "/partner/blocked/client/list",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Payments",
    route: "/payment",
    icon: "cil-list",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Repayment",
        to: "/baas/received",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Disbursement",
        to: "/baas/disbursement",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Refunds",
        to: "/baas/refund",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Accounts",
    route: "/corporate/",
    icon: "cil-bookmark",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Top Up",
        to: "/partner/topup",
      },
      // {
      //   _tag: "CSidebarNavItem",
      //   name: "Account Statement",
      //   to: "/partner/account/statement",
      // },
      {
        _tag: "CSidebarNavItem",
        name: "Cash Withdrawal",
        to: "/baas/initiated/withdrawal",
      },
      // {
      //   _tag: "CSidebarNavItem",
      //   name: "Settlements",
      //   to: "/partner/settlement",
      // },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Reports",
    route: "/notifications",
    icon: "cil-file",
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Sms Report",
        to: "/message/baas",
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Account Users",
    route: "/users",
    icon: "cil-user-unfollow",
    _children: [
      // {
      //   _tag: "CSidebarNavItem",
      //   name: "User list",
      //   to: "corporate/account/user",
      // },
      // {
      //   _tag: "CSidebarNavItem",
      //   name: "User Roles",
      //   to: "/user/roles",
      // },
    ],
  },
  {
    _tag: "CSidebarNavItem",
    name: "Settings",
    to: "/settings/preference",
    icon: "cil-settings",
  },
];
export default _navPartner;
